import { useParams } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import ArticleCard from "@/components/base/ArticleCard";
import { categories } from "@/mocks/categories";
import { getArticlesByCategory } from "@/mocks/articles";
import { siteInfo } from "@/mocks/siteInfo";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const articles = slug ? getArticlesByCategory(category?.id || "") : [];

  if (!category) {
    return (
      <>
        <Navbar />
        <main>
          <div className="max-w-7xl mx-auto px-4 md:px-6 pt-24 pb-20 text-center">
            <i className="ri-error-warning-line text-5xl text-foreground-300 w-12 h-12 flex items-center justify-center mx-auto mb-4"></i>
            <h1 className="text-2xl font-heading font-bold text-foreground-900 mb-2">分类未找到</h1>
            <p className="text-foreground-500">请检查链接是否正确</p>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: `${category.name} - ${siteInfo.name}`,
    description: category.description,
    url: `${siteInfo.url}/category/${category.slug}`,
    isPartOf: {
      "@type": "WebSite",
      name: siteInfo.name,
      url: siteInfo.url,
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>

      <Navbar />

      <main>
        <div className="pt-16 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: category.name },
              ]}
            />
          </div>
        </div>

        <section className="py-8 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="mb-10">
              <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-3 whitespace-nowrap">
                <i className={`${category.icon} w-3 h-3 flex items-center justify-center inline mr-1`}></i>
                {category.name}
              </span>
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-2">
                {category.name}
              </h1>
              <p className="text-sm text-foreground-500 max-w-2xl">{category.description}</p>
            </div>

            {articles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {articles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <i className="ri-inbox-line text-4xl text-foreground-300 w-10 h-10 flex items-center justify-center mx-auto mb-3"></i>
                <p className="text-foreground-500">该分类暂无内容</p>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}